<template>
  <div class="container-fluid post-job-box">
    <v-icon
      @click="closePreview"
      style="position: absolute; top: 0.5rem; right: 0; font-size: 2.5rem"
      class=""
      >mdi-close-box</v-icon
    >
    <div class="post-job">
      <div class="row">
        <div class="job-preview-body">
          <div class="row preview-content-top">
            <div
              class="col-sm-12 col-md-8 col-lg-8 col-xl-8 job-details-in-short"
            >
              <div class="row top-ttl">
                <div class="job-title">{{ title }}</div>
              </div>
              <div class="company-name">{{ company.company_name }}</div>
              <div class="deadline">
                <v-icon
                  style="margin-bottom: .3rem; margin-right:.5rem; color: var(--icon-grey-scale-color); font-size:1.3rem;"
                  color="#43a046"
                  >fa-clock</v-icon
                >
                <span style="margin-right: .5rem">Posted</span>
                <span class="deadline-text">{{ openingDate }}</span>
                <v-icon
                  style="margin-bottom: .3rem; margin-right: .5rem; color: var(--icon-grey-scale-color); font-size:1.3rem"
                  >fa-clock</v-icon
                >
                <span style="margin-right: .5rem">Deadline</span>
                <span class="deadline-text">{{ deadLine }}</span>
              </div>
              <div
                class="row"
                style="text-align: left; pointer-events: none; opacity: 0.5"
              >
                <div style="padding-right: 1.0rem">
                  <div class="btn-next">
                    Apply
                  </div>
                </div>
                <div>
                  <div class="btn-save-new">
                    Save
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-4 col-lg-4 col-xl-4 job-details-in-short phone-view"
            >
              <div
                v-if="allow_message"
                style="text-align:right; pointer-events: none; opacity: 0.5"
                class="message-box"
              >
                <v-icon style="color: var(--button-color);font-size:3.2rem"
                  >mdi-email</v-icon
                >
              </div>
              <div class="sim-comp">
                <span
                  style="font-size:1.4rem !important; pointer-events: none; opacity: 0.5;"
                  >Show other jobs from this company</span
                >
              </div>
            </div>
          </div>
          <div v-if="no_of_vacancy">
            <div class="row nice-to-have">
              Vacancy
            </div>
            <div class="row nice-to-have-content">
              {{ no_of_vacancy }}
            </div>
          </div>
          <div v-if="jobType">
            <div class="row job-type">Job Nature</div>
            <div class="row job-type-content">{{ jobType }}</div>
          </div>
          <div v-if="seniorityLevel">
            <div class="row seniority-level">Seniority Level</div>
            <div class="row seniority-level-content">{{ seniorityLevel }}</div>
          </div>
          <div v-if="details">
            <div class="row job-detail">Details</div>
            <div id="p" v-html="details" class="job-detail-content"></div>
          </div>
          <div v-if="jobresp">
            <div class="row nice-to-have">Job Responsibilities</div>
            <div v-html="jobresp" class="nice-to-have-content"></div>
          </div>
          <div v-if="degrees.length > 0">
            <div class="row skill">Degrees</div>
            <div class="row skill-content">
              <span
                :key="index"
                style="padding-right: .5rem"
                v-for="(degree, index) in degrees"
              >
                {{ degree.degree_name }}
                <span v-if="degree.major_name">in {{ degree.major_name }}</span>
                <span v-if="index < degrees.length - 1">,</span
                ><span v-else>.</span>
              </span>
            </div>
          </div>
          <div v-if="skillsText">
            <div class="row skill">Skills</div>
            <div class="row skill-content">{{ skillsText }}</div>
          </div>
          <div v-if="niceToHaveText">
            <div class="row nice-to-have">Nice to Have</div>
            <div v-html="niceToHaveText" class="nice-to-have-content"></div>
          </div>
          <div v-if="req_id">
            <div class="row nice-to-have">
              Req ID
            </div>
            <div class="row nice-to-have-content">
              {{ req_id }}
            </div>
          </div>
          <div v-if="location">
            <div class="row nice-to-have">
              Location
            </div>
            <div class="row nice-to-have-content">
              {{ location }}
            </div>
          </div>
          <div v-if="benefits">
            <div class="row nice-to-have">Benefits</div>
            <div v-html="benefits" class="nice-to-have-content"></div>
          </div>
          <div v-if="salaryText">
            <div class="row salary">Salary</div>
            <div class="row salary-content">{{ salaryText }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_LOCAL_TIME_FROM_UTC,
  GET_STRING_FROM_ARRAY,
  PHONE,
  SALARY_TEXT,
  GET_STRING_FROM_LIST_OF_SKILLS,
  MONTH_DATE_FORMAT
} from "../../../globalFunctions";
export default {
  name: "posted-jobs",
  components: {},
  props: {
    job: Object
  },
  data: function() {
    return {
      phone: PHONE(),
      company: this.$constants.getOwnerInfo(),
      title: null,
      no_of_vacancy: null,
      req_id: null,
      details: null,
      skillsText: null,
      niceToHaveText: null,
      jobresp: null,
      benefits: null,
      salaryText: null,
      openingDate: null,
      deadLine: null,
      jobType: null,
      seniorityLevel: null,
      applied: false,
      degrees: [],
      location: null,
      allow_message: null
    };
  },
  methods: {
    closePreview() {
      this.$emit("close-preview");
    }
  },
  mounted: function() {
    if (this.job) {
      this.title = this.job.job_title;
      this.job_id = this.job.job_id ? this.job.job_id : null;
      this.details = this.job.job_description
        ? this.job.rich_job_description
        : null;
      this.allow_message = this.job.allow_message;
      this.seniorityLevel = this.job.seniority_level
        ? GET_STRING_FROM_ARRAY(this.job.seniority_level, ", ", true)
        : null;
      this.jobType = this.job.position_type
        ? GET_STRING_FROM_ARRAY(this.job.position_type, ", ")
        : null;
      this.skillsText = this.job.skills
        ? GET_STRING_FROM_LIST_OF_SKILLS(this.job.skills, ", ")
        : null;
      if (this.job.degrees) {
        this.degrees = this.job.degrees;
      }
      if (this.job.close_date) {
        this.deadLine = MONTH_DATE_FORMAT(
          GET_LOCAL_TIME_FROM_UTC(this.job.close_date)
        );
      }
      if (this.job.open_date) {
        this.openingDate = MONTH_DATE_FORMAT(
          GET_LOCAL_TIME_FROM_UTC(this.job.open_date)
        );
      }
      if (this.job.location_name) {
        this.location = this.job.location_name;
      }
      if (this.job.nice_to_have) {
        this.niceToHaveText = this.job.rich_nice_to_have;
      }
      if (this.job.job_responsibilities) {
        this.jobresp = this.job.rich_job_responsibilities;
      }
      if (this.job.job_benefits) {
        this.benefits = this.job.rich_job_benefits;
      }
      if (this.job.no_of_vacancy) {
        this.no_of_vacancy = this.job.no_of_vacancy;
      }
      if (this.job.req_id) {
        this.req_id = this.job.req_id;
      }
      if (this.job.min_salary && this.job.max_salary) {
        this.salaryText = SALARY_TEXT(
          this.job.min_salary,
          this.job.max_salary,
          this.job.negotiable,
          this.job.salary_basis
        );
      } else {
        if (this.job.min_salary || this.job.max_salary) {
          this.salaryText = this.job.min_salary || this.job.max_salary;
        }
        if (this.job.negotiable) {
          this.salaryText = this.salaryText
            ? (this.salaryText += " (Negotiable)")
            : "Negotiable";
        }
      }
    }
  }
};
</script>

<style scoped>
.post-job-box {
  background-color: #ffffff;
  padding: 3rem 2rem !important;
}
.job-preview-body {
  width: 100%;
}
.preview-content-top {
  padding-bottom: 1rem;
  border-bottom: 0.1rem solid #eeeeee;
}
.company-logo {
  padding: 0 0 1rem 0;
  text-align: left;
}
.job-details-in-short {
  padding: 0 0 1rem 0;
}
.top-ttl {
  position: relative;
}
.job-title {
  font-size: 2.8rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #050405;
}
.company-name {
  margin-top: 1rem;
  font-size: 1.6rem;
  line-height: 1.5;
  text-align: left;
  color: #050505;
}
.deadline {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.25;
  text-align: left;
}
.deadline-text {
  font-size: 1.4rem;
  line-height: 1.25;
  text-align: left;
  color: #050405;
  margin-right: 1rem;
}
.sim-comp {
  position: absolute;
  bottom: 1rem;
  right: 0;
  text-align: left;
  padding: 1.5rem 0 0 0;
  color: var(--link-color);
}
.seniority-level {
  padding: 2rem 0 1rem 0;
  /*font-size: 1.4rem;*/
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
}
.seniority-level-content {
  /*font-size: 1.2rem;*/
  font-size: 1.4rem;
  text-align: left;
}
.job-type {
  padding: 2rem 0 1rem 0;
  /*padding-top: .5rem;*/
  font-size: 1.6rem;
  /*font-size: 1.4rem;*/
  font-weight: bold;
  text-align: left;
}
.job-type-content {
  /*font-size: 1.2rem;*/
  font-size: 1.4rem;
  text-align: left;
}
.job-details-in-short-right {
  padding: 1.7rem 0 0 0;
}
.job-detail {
  padding: 2rem 0 1rem 0;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
}
.job-detail-content {
  font-size: 1.4rem;
  text-align: left;
}
.skill {
  padding: 2rem 0 1rem 0;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
}
.skill-content {
  font-size: 1.4rem;
  text-align: left;
}
.nice-to-have {
  padding: 2rem 0 1rem 0;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
}
.nice-to-have-content {
  font-size: 1.4rem;
  text-align: left;
}
.salary {
  padding: 2rem 0 1rem 0;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
}
.salary-content {
  font-size: 1.4rem;
  text-align: left;
}
@media (max-width: 1366px) {
  .post-job-box {
    padding: 0rem;
  }
  .job-preview-body {
    padding: 1.5rem;
  }
}
@media (max-width: 600px) {
  .post-job-box {
    padding: 2rem 2rem;
  }
  .job-preview-body {
    padding: 1rem;
    width: 100%;
  }
  .job-preview-body::-webkit-scrollbar {
    display: none;
  }
  .job-details-in-short {
    width: 100%;
  }
  .btn-back {
    min-width: 4rem;
  }
  .btn-close {
    min-width: 4rem;
  }
}
</style>
